import { render, staticRenderFns } from "./Alliance.vue?vue&type=template&id=7d9d4a2b&scoped=true"
import script from "./Alliance.vue?vue&type=script&lang=js"
export * from "./Alliance.vue?vue&type=script&lang=js"
import style0 from "./Alliance.vue?vue&type=style&index=0&id=7d9d4a2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9d4a2b",
  null
  
)

export default component.exports